<script setup lang="ts">
import '@/assets/styles/legal.css'
</script>

<template>
  <div class="legal-page">
    <section class="legal-card">
      <h1>Impressum</h1>

      <h2>Angaben gemaess § 5 DDG</h2>
      <p>
        KFZ Musterwerkstatt<br />
        Vertreten durch: Max Mustermann<br />
        Musterstraße 12<br />
        12345 Musterstadt
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: 01234 567890<br />
        E-Mail: info@musterwerkstatt.example
      </p>

      <h2>Umsatzsteuer-Identifikationsnummer</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemaess § 27 a Umsatzsteuergesetz:<br />
        <strong>DE123456789 (Beispielangabe)</strong>
      </p>

      <h2>Aufsichtsbehoerde</h2>
      <p>
        Handwerkskammer Musterstadt<br />
        Beispielweg 1<br />
        12345 Musterstadt
      </p>

      <h2>Berufsbezeichnung</h2>
      <p>
        Kraftfahrzeugtechnikermeister, verliehen in der Bundesrepublik Deutschland.
      </p>

      <h2>Verantwortlich fuer den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>
        Max Mustermann<br />
        Musterstraße 12<br />
        12345 Musterstadt
      </p>

      <h2>Haftung fuer Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir nach den allgemeinen Gesetzen fuer eigene
        Inhalte auf diesen Seiten verantwortlich. Wir pruefen und aktualisieren
        die Inhalte dieser Website mit Sorgfalt.
      </p>

      <h2>Haftung fuer Links</h2>
      <p>
        Unser Angebot enthaelt Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Fuer diese fremden Inhalte uebernehmen
        wir keine Gewaehr.
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Beitraege Dritter sind als
        solche gekennzeichnet.
      </p>
    </section>
  </div>
</template>
